import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { AddressInterface } from '../../../../account/models/address.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { AddressInterfaceState } from '../../../../account/store/state/address.state';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';
import { GetAddress } from '../../../../account/store/actions/address.actions';
import { SaveMission, UpdateMission } from '../../../store/actions/mission.actions';
import { SimChoiceInterface } from '../../../models/sim-choice.interface';
import { SimChoiceInterfaceState } from '../../../store/state/sim-choice.state';
import { UpdateSimChoice } from '../../../store/actions/sim-choice.actions';
import { UpdateMfaVisibility } from '../../../store/actions/mfa.actions';
import { ExtranetService } from '../../../services/extranet.service';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import { environment } from '../../../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerInterface } from '../../../../account/models/customer.interface';

@Component({
  selector: 'app-loss-steal',
  templateUrl: './loss-steal.component.html',
  styleUrls: ['./loss-steal.component.css'],
  standalone: false
})
export class LossStealComponent implements OnInit, AfterViewChecked {

  step: number;
  steps: number;
  simChoiceInterface: SimChoiceInterface;

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  procedureStatus: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  shippingAddress: AddressInterface|null;
  validation: string;
  displayErrorMessage: boolean;
  brand?: string;
  addressFrom: FormGroup;
  addressFromSubmitted: boolean;
  customer: CustomerInterface;
  civility = 'Mr';
  errors: any = {
    lastName: {
      required: `Le nom est obligatoire.`,
      pattern: 'Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.'
    },
    firstName: {
      required: `Le prénom est obligatoire.`,
      pattern: `Veuillez saisir un prénom sans accent, caractères spéciaux ni chiffres.`
    },
    company: {
      pattern: `Veuillez saisir un nom de société sans accent ni caractères spéciaux.`
    },
    label: {
      required: `Un nom d'adresse est obligatoire.`,
      pattern: `Veuillez saisir un nom d'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    street: {
      required: `L'adresse' est obligatoire.`,
      pattern: `Veuillez saisir une adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    zipCode: {
      required: `Le code postal est obligatoire.`,
      pattern: `Le code postal saisie n'est pas valide.`
    },
    city: {
      required: `La ville est obligatoire.`,
      pattern: `Veuillez saisir un nom de ville sans accent, caractères spéciaux ni chiffres.`
    },
    addressComplement: {
      pattern: `Veuillez saisir un complément d\'adresse avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    },
    placeName: {
      pattern: `Veuillez saisir un lieu-dit avec au moins deux caractères et sans utiliser de caractères spéciaux ni accent.`
    }
  };

  constructor(
      private formBuilder: FormBuilder,
      private store: Store<any>,
      private extranetService: ExtranetService,
      private customerStorageService: CustomerStorageService
  ) {}

  ngOnInit() {
    this.shippingAddress = null;
    this.brand = environment.data.brand;
    this.store.dispatch(new GetAddress());
    this.displayErrorMessage = false;
    this.validation = null;
    this.step = 1;
    this.steps = 3;
    this.simChoiceInterface = {
      esimPhone: null,
      simChoice: 4,
      displayErrorMessage: false
    } as SimChoiceInterface;
    this.addressFromSubmitted = false;
    this.store.pipe(select(ConstsHelper.REDUCER_ADDRESS)).subscribe( (result: AddressInterfaceState) => {
      if (null != result.address) {
        for (const addr of result.address) {
          if (addr.isPrincipal) {
            this.shippingAddress = addr;
            this.initShippingAddressFrom();
          }
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SIM_CHOICE)).subscribe((response: SimChoiceInterfaceState) => {
      if (null !== response.simChoice) {
        this.simChoiceInterface = response.simChoice;
        this.steps = (this.simChoiceInterface.simChoice === 4) ? 3 : 2;
      }
    });
  }

  initShippingAddressFrom() {
    this.civility = this.shippingAddress.civility !== '' ? this.shippingAddress.civility : 'Mr';
    this.addressFrom = this.formBuilder.group({});
    this.addressFrom.addControl('firstName', this.formBuilder.control(this.shippingAddress.firstName, [Validators.required, Validators.pattern(ConstsHelper.firstNamePattern)]));
    this.addressFrom.addControl('lastName', this.formBuilder.control(this.shippingAddress.lastName, [Validators.required, Validators.pattern(ConstsHelper.lastNamePattern)]));
    this.addressFrom.addControl('company', this.formBuilder.control(this.shippingAddress.company, [Validators.pattern(ConstsHelper.companyPattern)]));
    this.addressFrom.addControl('label', this.formBuilder.control(this.shippingAddress.label, [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('street', this.formBuilder.control(this.shippingAddress.street, [Validators.required, Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('addressComplement', this.formBuilder.control(this.shippingAddress.addressComplement, [Validators.pattern(ConstsHelper.addressPattern)]));
    this.addressFrom.addControl('zipCode', this.formBuilder.control(this.shippingAddress.zipCode, [Validators.required, Validators.pattern(ConstsHelper.zipCodePattern)]));
    this.addressFrom.addControl('city', this.formBuilder.control(this.shippingAddress.city, [Validators.required, Validators.pattern(ConstsHelper.cityPattern)]));
    this.addressFrom.addControl('placeName', this.formBuilder.control(this.shippingAddress.placeName, [Validators.pattern(ConstsHelper.addressPattern)]));
  }
  ngAfterViewChecked() {
    document.getElementById('top').scrollTo(0, 0);
  }

  setStep(step: number) {
    this.displayErrorMessage = false;
    if (this.step === 1 && this.validation == null && this.procedureStatus === 'wait_form') {
      this.displayErrorMessage = true;
    } else {
      this.step = step;
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.addressFrom.controls[formControlName].invalid) {
      Object.keys(this.addressFrom.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  sendRequest() {
    this.addressFromSubmitted = true;
    if (this.addressFrom.valid) {
      this.shippingAddress.civility = this.civility;
      this.shippingAddress.firstName = this.addressFrom.get('firstName').value;
      this.shippingAddress.lastName = this.addressFrom.get('lastName').value;
      this.shippingAddress.company = this.addressFrom.get('company').value;
      this.shippingAddress.street = this.addressFrom.get('street').value;
      this.shippingAddress.addressComplement = this.addressFrom.get('addressComplement').value;
      this.shippingAddress.zipCode = this.addressFrom.get('zipCode').value;
      this.shippingAddress.city = this.addressFrom.get('city').value;
      this.shippingAddress.placeName = this.addressFrom.get('placeName').value;
      this.shippingAddress.label = this.addressFrom.get('label').value;
    }
    if (this.step === 2 && this.simChoiceInterface.displayErrorMessage === true) {
      this.simChoiceInterface.displayErrorMessage = true;
      this.store.dispatch(new UpdateSimChoice(this.simChoiceInterface));
    } else {
      let myEffect: any;
      const orderSimCardInterface = {
        step: 1,
        routeValue: null,
        phoneNumber: this.line.phoneNumber,
        simType: this.simChoiceInterface.simChoice,
        esimPhone: this.simChoiceInterface.esimPhone,
        shippingAddressId: this.shippingAddress.id,
        shippingAddress: this.shippingAddress,
      };
      if (this.procedureStatus === 'finished') {
        orderSimCardInterface.routeValue = 'ec_request';
        myEffect = SaveMission;
      } else {
        orderSimCardInterface.routeValue = this.validation === '1' ? 'confirm_loss' : 'cancel_loss';
        myEffect = UpdateMission;
      }
      if (this.extranetService.getSupportUser() || orderSimCardInterface.simType === 4) {
        this.store.dispatch(new myEffect(orderSimCardInterface, this.procedureCode));
      } else if (this.customerStorageService.getCustomer()) {
        this.store.dispatch(
            new UpdateMfaVisibility(
                {
                  visibility: true,
                  action: this.procedureCode,
                  step: 1,
                  destination: this.customerStorageService.getCustomer().email ,
                  code: null,
                  errorMessage: null,
                  effect: myEffect,
                  effectData: orderSimCardInterface
                }
            )
        );
      }
    }
  }
}
